<template>
    <div>
        <div id="fullcontent">
            <router-view />
        </div>
    </div>
</template>

<script>
import { Api } from '@/core/api.js'
const api = new Api()

export default {
    components: {},
    data() {
        return {}
    },
    methods: {
        getCookie(name) {
            const value = `; ${document.cookie}`
            const parts = value.split(`; ${name}=`)
            if (parts.length === 2) return parts.pop().split(';').shift()
        },
        popupGeolocation() {
            var self = this
            if (
                navigator.permissions.query({ name: 'geolocation' }).then(function (permissionStatus) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            console.log('GETTING POSITION: ', position)
                            var coords = { latitude: position.coords.latitude, longitude: position.coords.longitude }
                            self.$store.commit('setGeoLocation', coords)
                        },
                        function (error) {
                            console.log('ERROR GEOLOCATION -> ', error)
                            if (error.code == 3) {
                                setTimeout(self.popupGeolocation, 10 * 60 * 1000)
                            }
                        },
                        { timeout: 3000 }
                    )
                }) == undefined
            ) {
            }
            navigator.permissions.query({ name: 'geolocation' }).then(function (permissionStatus) {
                console.log('GEO', permissionStatus)
                setTimeout(function () {
                    var popupPrinter = document.querySelector('body > div.popup-container.popup-label-admin')

                    if (permissionStatus.state == 'prompt' && popupPrinter == null) {
                        self.$popup.geolocation({
                            mood: 'geolocation'
                        })
                    }
                }, 600)
            })
        },
    },
    created() {
        //this.$bar.hide()
        this.$store.commit('setMediaQuery', this.$mq)

        // PORTRAIT LOCK
        if (['portrait'].includes(this.$mq) && this.$store.getters.getIsApp) {
            screen.orientation.lock('portrait')
        }

        if (!this.$store.getters.getIsApp) {
            log('COOKIE -> ', document.cookie)
            if (!this.getCookie('usernameAndy')) {
                document.cookie = 'usernameAndy=' + uuid.v4()
                this.$store.commit('setUuid', document.cookie)    
            } else {
                this.$store.commit('setUuid', this.getCookie('usernameAndy'))
            }
        } else {
            this.$store.commit('setUuid', window.device.uuid)
        }
        if (process.env.VUE_APP_IS_APP == 'FALSE') {
            this.popupGeolocation()
        }
    },
    destroyed() {
        // ORIENTATION UNLOCK
        screen.orientation.unlock()
    }
}
</script>

<style lang="scss">
#fullcontent.inLogin {
    @include display-flex();
    @include justify-content();
    @include align-items();
    width: 100%;
    height: 100%;
    z-index: $z-content;
    position: absolute;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: $default-bg-color;
}
</style>
